/**
 * Pointer drag / swipe on hero slideshow (slideshow.liquid only).
 * Drag left → next slide; drag right → previous. Delegates to Dawn prev/next buttons.
 */
(function () {
  const DRAG_THRESHOLD = 50;
  const CLICK_SLOP = 12;
  const SUPPRESS_CLICK_MS = 400;

  const INTERACTIVE =
    'a[href], button, input, textarea, select, label, .slider-button, .slider-counter__link, .slideshow__autoplay';

  function isInteractiveTarget(target) {
    return Boolean(target && target.closest && target.closest(INTERACTIVE));
  }

  function bindSlideshow(slideshow) {
    if (slideshow.dataset.hokSlideshowDragBound === 'true') return;
    if (slideshow.getAttribute('data-hok-slideshow-drag') !== 'true') return;

    const slider = slideshow.querySelector('[id^="Slider-"]');
    const prevButton = slideshow.querySelector('button[name="previous"]');
    const nextButton = slideshow.querySelector('button[name="next"]');
    const slides = slideshow.querySelectorAll('[id^="Slide-"]');

    if (!slider || !prevButton || !nextButton || slides.length < 2) return;

    slideshow.dataset.hokSlideshowDragBound = 'true';

    let activePointerId = null;
    let startX = 0;
    let startY = 0;
    let didExceedClickSlop = false;
    let suppressClickUntil = 0;

    function resetPointerState() {
      activePointerId = null;
      didExceedClickSlop = false;
      slideshow.classList.remove('hok-slideshow-drag--active');
    }

    function navigateFromDrag(deltaX) {
      if (Math.abs(deltaX) < DRAG_THRESHOLD) return;
      const button = deltaX < 0 ? nextButton : prevButton;
      button.click();
    }

    slider.addEventListener(
      'pointerdown',
      (event) => {
        if (event.button !== 0) return;
        if (isInteractiveTarget(event.target)) return;

        activePointerId = event.pointerId;
        startX = event.clientX;
        startY = event.clientY;
        didExceedClickSlop = false;
        slideshow.classList.add('hok-slideshow-drag--active');

        if (slider.setPointerCapture) {
          try {
            slider.setPointerCapture(event.pointerId);
          } catch (_) {
            /* ignore */
          }
        }
      },
      { passive: true }
    );

    slider.addEventListener(
      'pointermove',
      (event) => {
        if (activePointerId !== event.pointerId) return;

        const deltaX = event.clientX - startX;
        const deltaY = event.clientY - startY;

        if (!didExceedClickSlop) {
          if (Math.abs(deltaX) > CLICK_SLOP || Math.abs(deltaY) > CLICK_SLOP) {
            didExceedClickSlop = true;
          }
        }

        if (didExceedClickSlop && Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > CLICK_SLOP) {
          if (event.cancelable) event.preventDefault();
        }
      },
      { passive: false }
    );

    function finishDrag(event) {
      if (activePointerId !== event.pointerId) return;

      const deltaX = event.clientX - startX;

      if (slider.releasePointerCapture) {
        try {
          slider.releasePointerCapture(event.pointerId);
        } catch (_) {
          /* ignore */
        }
      }

      if (didExceedClickSlop && Math.abs(deltaX) >= DRAG_THRESHOLD) {
        navigateFromDrag(deltaX);
        suppressClickUntil = Date.now() + SUPPRESS_CLICK_MS;
      }

      resetPointerState();
    }

    slider.addEventListener('pointerup', finishDrag);
    slider.addEventListener('pointercancel', (event) => {
      if (activePointerId === event.pointerId) resetPointerState();
    });

    slider.addEventListener(
      'click',
      (event) => {
        if (Date.now() < suppressClickUntil && !isInteractiveTarget(event.target)) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      },
      true
    );
  }

  function init(root) {
    (root || document)
      .querySelectorAll('slideshow-component[data-hok-slideshow-drag="true"]')
      .forEach(bindSlideshow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
